export default __webpack_public_path__ + "static/media/logo-white.d0364382.svg";